const DB_NAME = "_evol_spearup_db_1";

const deleteLocalDb = () => {
  return new Promise((resolve, reject) => {
    if (!window.indexedDB) {
      console.warn("IndexedDB not supported");
      resolve();
      return;
    }

    const req = indexedDB.deleteDatabase(DB_NAME);

    req.onsuccess = () => {
      //console.log("✅ IndexedDB deleted");
      resolve();
    };

    req.onerror = () => {
     // console.error("❌ Failed to delete IndexedDB");
      reject(new Error("Delete DB failed"));
    };

    req.onblocked = () => {
      //console.warn("⚠️ IndexedDB delete blocked (close other tabs)");
    };
  });
};

export default deleteLocalDb;
